import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n, {
  isAuthPage,
  parseUrlLanguageParam,
  setStoredLanguage,
} from '@/i18n';

/**
 * 在登录/注册等认证页，根据 URL 中的 lang 参数同步本地化语言。
 * 若语言与当前不一致，会持久化并刷新页面以同步 Clerk 本地化配置。
 */
const useAuthPageLanguageFromUrl = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!isAuthPage(pathname)) {
      return;
    }

    const urlLanguage = parseUrlLanguageParam(search);
    if (!urlLanguage) {
      return;
    }

    setStoredLanguage(urlLanguage);

    if (urlLanguage !== i18n.language) {
      i18n.changeLanguage(urlLanguage);
      window.location.reload();
    }
  }, [pathname, search]);
};

export default useAuthPageLanguageFromUrl;
